

























import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';

@Component({
  name: 'InfoLabel',
})
export default class AmetrasInfoLabelFieldTemplate extends Vue {

  @Prop() fieldDefinition!: DisguiseDto.FTInfoLabelDto;

  iconService: IconsService = ICONS_SERVICE_INSTANCE;

  getAlertType(fieldDefinition: DisguiseDto.FTInfoLabelDto): 'info' | 'warning' | 'success' | 'error' {
    let result: 'info' | 'warning' | 'success' | 'error' = 'info';
    if (fieldDefinition && fieldDefinition.serenity) {
      switch (fieldDefinition.serenity) {
        case 'ERROR':
          result = 'error';
          break;
        case 'INFO':
          result = 'info';
          break;
        case 'SUCCESS':
          result = 'success';
          break;
        case 'WARNING':
          result = 'warning';
          break;
        default:
          break;
      }
    }
    return result;
  }
}
